define('modules/start/products/landings/logobutton/view',['require','exports','module','env','../../base/logobutton/view'],function(require, exports, module) {
    "use strict";

    var Config = require("env");
    var BaseLogobuttonView = require("../../base/logobutton/view");

    var Layout = BaseLogobuttonView.extend({
        privateUrl: Config.landingsUrl,
        defaultDomain: Config.defaultDomain,
        serviceName: 'landings',
        logoName:'ic_LP-mod_productos',
        redirect: function() {
            window.location = this.privateUrl + '/?company_id=' + this.companyId;
        }
    });

    module.exports = Layout;
});
